$(document).ready(function() {
  $('.priceModalBtn').on('click', function(){
    let priceId = $(this).data('id')
    fetchPriceDetail(priceId)
    $('#PriceOverlay').modal('show')
  })

  $('#PriceOverlay').on('show.bs.modal', function (e) {
     window.setTimeout(function(){
      $('.modal-content').scrollTop(0)
    }, 500)
  })
})

const fetchPriceDetail = async function(priceId){
  await $.ajax({
    url: `/map/api/prices/${priceId}`,
    type: 'GET',
    dataType: 'json',
  }).done(function(data){
    data = data['price']
    let aboutPlanTitle = ''
    if(data['payment_type'] == '入居金型'){
      aboutPlanTitle = '【入居金型プランについて】'
    }else if(data['payment_type'] == '月額支払い型'){
      aboutPlanTitle = '【月額型プランについて】'
    }

    // プラン概要
    $('#pTitle').html(data['title'])
    $('#pPaymentType').html(data['payment_type'])
    $('#pAboutPlanTitle').html(aboutPlanTitle)
    $('#pAboutPlan').html(data['about_plan'].replace(/\n/g, "<br>"))

    //入居金
    $('#pInitialFee').html(data['initial_fee'])
    $('#pAboutInitialFee').html(data['about_initial_fee'].replace(/\n/g, "<br>"))

    //敷金
    $('#pShikikin').html(data['shikikin'])
    $('#pAboutShikikin').html(data['about_shikikin'])

    // 共益費
    if(data['care_home_service_type'] == 'b_paid_nursing_home_with_care_1'){
      $('#pCommonServiceFee').html(data['common_service_fee'])
    }else if(data['common_service_fee'] != '0円'){
      $('#pCommonServiceFee').html(data['common_service_fee'])
    }else{
      $('#commonServiceFeeArea').remove()
    }

    //保証金
    $('#pDeposit').html(data['deposit'])
    $('#pAboutDeposit').html(data['about_deposit'])

    //返還制度
    $('#pInitialAmortizationRate').html(data['initial_amortization_rate'])
    $('#pAmortizationTerm').html(data['amortization_term'])

    // 月額費用
    $('#pMonthlyTotalWithTax').html(data['monthly_total_with_tax'])

    //家賃
    $('#pRent').html(data['rent'])

    //食材費
    $('#pFoodCostWithTax').html(data['food_cost_with_tax'])
    $('#pAboutFoodCost').html(data['about_food_cost'].replace(/\n/g, "<br>"))

    //管理費
    $('#pManagementFeeWithTax').html(data['management_fee_with_tax'])
    $('#pAboutManagementFee').html(data['about_management_fee'].replace(/\n/g, "<br>"))

    //上乗せ介護費用
    if(data['addon_nursing_fee_with_tax'] == '0円(税込)'){
      $('#addonNursingFeeArea').remove()
      $('#aboutAddonNursingFeeArea').remove()
    }else{
      $('#pAddonNursingFeeWithTax').html(data['addon_nursing_fee_with_tax'])
      $('#pAboutAddonNursingFee').html(data['about_addon_nursing_fee'].replace(/\n/g, "<br>"))
    }

    //生活支援費用
    if(data['lifesupport_fee_with_tax'] == '0円(税込)'){
      $('#lifesupportFeeArea').remove()
    }else{
      $('#pLifesupportFeeWithTax').html(data['lifesupport_fee_with_tax'])
    }

    // 介護度に応じた注意事項
    $('#pCautionByDegree').html(data['caution_by_degree'].replace(/\n/g, "<br>"))

    //介護保険自己負担がく
    $('#pOthersOne').html(data['others_one'].replace(/\n/g, "<br>"))
    $('#pOthersTwo').html(data['others_two'].replace(/\n/g, "<br>"))
    $('#pOthersThree').html(data['others_three'].replace(/\n/g, "<br>"))
    $('#pSupportOneTenPercent').html(data['support_one_ten_percent'])
    $('#pSupportTwoTenPercent').html(data['support_two_ten_percent'])
    $('#pCareOneTenPercent').html(data['care_one_ten_percent'])
    $('#pCareTwoTenPercent').html(data['care_two_ten_percent'])
    $('#pCareThreeTenPercent').html(data['care_three_ten_percent'])
    $('#pCareFourTenPercent').html(data['care_four_ten_percent'])
    $('#pCareFiveTenPercent').html(data['care_five_ten_percent'])
    $('#pAboutSelfPayAmount').html(data['about_self_pay_amount'].replace(/\n/g, "<br>"))

    // 更新日
    $('#pUpdatedDate').html(data['updated_date'])

  })
}


